import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faGithubSquare, faBehanceSquare, faDribbbleSquare, faTwitterSquare } from '@fortawesome/free-brands-svg-icons';

import './Footer.css';

class Footer extends Component {

    render() {
        return (
            <footer className='text-center'>
                <Container>

                    <Row>
                        <Col>

                            <ul className='list-inline'>
                                <li>
                                    <a className='social-icon' href='https://www.linkedin.com/in/graeme-richard-james-brown/'>
                                        <FontAwesomeIcon icon={ faLinkedin } size='2x' />
                                    </a>
                                </li>
                                <li>
                                    <a className='social-icon' href='https://github.com/GraemeRJBrown'>
                                        <FontAwesomeIcon icon={ faGithubSquare } size='2x' />
                                    </a>
                                </li>
                                <li>
                                    <a className='social-icon' href='https://www.behance.net/GraemeRJBrown'>
                                        <FontAwesomeIcon icon={ faBehanceSquare } size='2x' />
                                    </a>
                                </li>
                                <li>
                                    <a className='social-icon' href='https://dribbble.com/GraemeRJBrown'>
                                        <FontAwesomeIcon icon={ faDribbbleSquare } size='2x' />
                                    </a>
                                </li>
                                <li>
                                    <a className='social-icon' href='https://twitter.com/GraemeRJBrown'>
                                        <FontAwesomeIcon icon={ faTwitterSquare } size='2x' />
                                    </a>
                                </li>
                            </ul>

                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <p>
                                <small className='copyright'>Copyright &copy; {this.getYear()}, Graeme Brown. All Rights Reserved.</small>
                            </p>
                        </Col>
                    </Row>

                </Container>
            </footer>
        );
    }

    getYear() {
        return Math.max(new Date().getFullYear(), 2020);
    }

}

export default Footer;